import React, { useCallback, useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { loadTournamentsIndex } from "@tennis-matches/services/tournaments";
import { clearLocalState } from "@tennis-matches/services/persistence";
import {
  ClubChampHubDashboard,
  __isClubChampKind,
} from "../../components/hub/clubchamp/ClubChampHubDashboard.jsx";

/**
 * App-Index `/clubmeisterschaft` – gleiches Dashboard wie der Hub.
 */
export function ClubChampIndexPage() {
  const outlet = useOutletContext() || {};
  const t = typeof outlet.t === "function" ? outlet.t : (k) => k;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    loadTournamentsIndex({ includePlayerCounts: true, includeArchived: true })
      .then((indexRes) => {
        if (cancelled) return;
        const all = Array.isArray(indexRes?.tournaments)
          ? indexRes.tournaments
          : [];
        setItems(all.filter((row) => __isClubChampKind(row?.kind)));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const onNewTournament = useCallback(() => {
    if (typeof outlet.onNewTournament === "function") {
      outlet.onNewTournament();
      return;
    }
    clearLocalState({ keepTenant: true });
  }, [outlet]);

  return (
    <div className="page--hub page--hub-matchmixer page--hub-clubchamp mm-hub">
      <main className="hub-page-main page-container">
        <ClubChampHubDashboard
          t={t}
          items={items}
          loading={loading}
          onNewTournament={onNewTournament}
        />
      </main>
    </div>
  );
}
